import React from "react";
import {Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField, Typography} from "@mui/material";
import {grey} from "@mui/material/colors";

import {COUNTRIES} from "@/utils/constants";
import {Country} from "@/types/utils";

// function countryToFlag(isoCode: string) {
//     return typeof String.fromCodePoint !== "undefined" ? isoCode.toUpperCase().replace(/./g, (char: string) => String.fromCodePoint(char.charCodeAt(0) + 127397)) : isoCode;
// }

const CountrySelectAutocomplete = React.forwardRef(({onChange, ...props}: any, ref) => {
    return (
        <Autocomplete
            ref={ref}
            {...props}
            size="small"
            options={COUNTRIES}
            autoHighlight
            disableClearable
            isOptionEqualToValue={(option: any, value) => option?.label === value?.label}
            renderOption={(props: any, option: Country) => {
                return (
                    <Typography {...props} p={1} fontSize={13}
                                sx={{cursor: 'pointer', "&:hover": {bgcolor: grey[100]}}}>
                        {option.label}
                    </Typography>
                )
            }}
            onChange={(_event: any, option: Country) => onChange(option)}
            renderInput={(params) => {
                return (
                    <TextField
                        {...params}
                        label="Country"
                        variant="outlined"
                        inputProps={{
                            ...params.inputProps,
                            sx: {
                                fontSize: 13,
                                bgcolor: 'white'
                            },
                            autoComplete: "new-password"
                        }}
                        InputLabelProps={{
                            shrink: true,
                            sx: {
                                fontSize: 16
                            }
                        }}
                        sx={{
                            ".MuiInputBase-root": {
                                borderRadius: 0
                            },
                            "& input": {fontSize: 13}
                        }}
                    />
                )
            }}
        />
    );
});

const CountrySelect = React.forwardRef((props: any, ref) => {
    return (
        <FormControl fullWidth>
            <InputLabel id="country">Country (*)</InputLabel>
            <Select
                ref={ref}
                labelId="country"
                label="Country (*)"
                size="small"
                {...props}
            >
                {COUNTRIES.map((item: any) => {
                    return (
                        <MenuItem value={item.label} key={item.label}>
                            <Typography fontSize={14} sx={{mt: '2.5px'}}>{item.label}</Typography>
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
});

export {
    // eslint-disable-next-line react-refresh/only-export-components
    COUNTRIES,
    CountrySelectAutocomplete
};

export default CountrySelect